<pfx-entity-header-base-data>
  <ng-template pfxTemplate="column">
    <div class="flex flex-col gap-2">
      @if (dependentName(); as dependentName) {
        <pfx-icon-with-text [icon]="dependentIcon.icon">
          <a
            [routerLink]="['/business-partner-center', order()?.partners?.dependent?._id]"
            class="p-0 font-bold p-button-link"
            >{{ dependentName }}</a
          ></pfx-icon-with-text
        >
      }

      @if (dependentPhone(); as dependentPhone) {
        <pfx-icon-with-text [icon]="icons.phone">
          <a [href]="'tel://' + dependentPhone"> {{ dependentPhone }}</a>
        </pfx-icon-with-text>
      }
    </div>
  </ng-template>

  <ng-template pfxTemplate="column">
    <div class="flex flex-col gap-2">
      @if (caregiverName(); as caregiverName) {
        <pfx-icon-with-text
          [icon]="caregiverIcon.icon"
          [text]="caregiverName"
        ></pfx-icon-with-text>
      }

      @if (caregiverPhone(); as caregiverPhone) {
        <pfx-icon-with-text [icon]="icons.phone">
          <a [href]="'tel://' + caregiverPhone"> {{ caregiverPhone }}</a>
        </pfx-icon-with-text>
      }
    </div>
  </ng-template>

  <ng-template pfxTemplate="column">
    @if (attendances(); as attendances) {
      <div class="flex flex-col gap-2">
        <ul class="p-0 m-0 list-none">
          @for (attendance of attendances; track attendance) {
            <li>
              <pfx-icon-with-text
                [icon]="icons.attendance"
                [text]="attendance"
              ></pfx-icon-with-text>
            </li>
          }
        </ul>
      </div>
    }
    @if (activities(); as activities) {
      <div class="flex flex-col gap-2">
        <ul class="p-0 m-0 list-none">
          @for (activity of activities; track activity) {
            <li>
              <pfx-icon-with-text
                [icon]="icons.attendance"
                [text]="activity"
              ></pfx-icon-with-text>
            </li>
          }
        </ul>
      </div>
    }
  </ng-template>

  <ng-template pfxTemplate="column">
    <div class="flex flex-col gap-2">
      @if (period(); as period) {
        <pfx-icon-with-text
          [icon]="icons.period"
          [text]="period"
        ></pfx-icon-with-text>
      }

      @if (frequency(); as frequency) {
        <pfx-icon-with-text
          [icon]="icons.frequency"
          [text]="frequency"
        ></pfx-icon-with-text>
      }
      @if (documentNumber(); as documentNumber) {
        <pfx-icon-with-text
          [icon]="icons.documentNumber"
          [text]="documentNumber"
          pTooltip="{{ orderId() }}"
        ></pfx-icon-with-text>
      }
    </div>
  </ng-template>
</pfx-entity-header-base-data>
